<template>
    <div>
        <router-view />
        <van-tabbar class="layout-tabbar" route  active-color="#1486FB">
            <van-tabbar-item name="AgentHomepage" icon="home-o"  :to="{name: 'AgentHomepage'}">首页</van-tabbar-item>
            <van-tabbar-item name="AgentMerchantCollect" icon="chart-trending-o"   :to="{name : 'AgentMerchantCollect'}">数据</van-tabbar-item>
            <van-tabbar-item name="MyAgent" icon="manager-o"   :to="{name : 'MyAgent'}">我的</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
export default {
    name: 'tabbar',
    data() {
        return {

        }
    },
    methods: {
    }
}
</script>

<style scoped></style>
